/* Elektrisches Racing – small enhancements for the theme's sidebar mega menu.
   Menu data comes from the "shop-mega" navigation menu. Level-3 items titled "# Heading" become column headings. */
(function () {
  var MQ = window.matchMedia('(min-width: 769px)');

  function upsize(img) {
    try {
      var u = new URL(img.currentSrc || img.src, location.href);
      if (!u.searchParams.has('width')) return;
      u.searchParams.set('width', '480');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = u.href;
    } catch (e) { /* keep original image */ }
  }

  // Photo overrides so tabs that share a first product still show different, real product photos.
  var TAB_IMAGES = {
    '/collections/light-bee': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/FullSizeRender_b996a545-cf22-4474-b52e-99db25d8e19d.jpg',
    '/collections/baja-designs-e-moto-lighting': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/06BA9D7D-595F-498C-9464-34938A72D645.jpg',
    '/collections/e-moto-wheels': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/20180913_073235_edited_edited.jpg',
    '/collections/e-moto-seat-covers': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/complete-seat-hardcore-gripper-grey.webp',
    '/collections/ford-bronco': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/44-0087-UP-FGXX.jpg',
    '/collections/truck-fog-light-kits': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/44-0081-UP-FGXX.jpg',
    '/collections/truck-wiring-harnesses': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/640192_0-FGXX.jpg',
    '/collections/baja-designs-truck-off-road': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/44-0008-FGXX.jpg',
    '/collections/truck-off-road-lighting': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/44-0021-FGXX.jpg',
    '/collections/e-moto-brakes-rotors': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/S-R220-F-OEM-1REAR.jpg',
    '/collections/e-moto-chains-sprockets': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/S-SURDRIVE-WITH-BOLTS--scaled.jpg',
    '/collections/e-moto-protection-guards': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/rearmuddy_png-100534-500x500.png',
    '/collections/utv-side-by-side': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/44-7088-FGXX.jpg',
    '/collections/baja-designs-utv-sxs-lighting': 'https://cdn.shopify.com/s/files/1/0765/2786/2038/files/54-0620-FGXX_58c357df-831a-4a71-97e9-c36c9a849c7f.jpg'
  };
  function path(h) { try { return new URL(h, location.href).pathname; } catch (e) { return h; } }

  // Shop All: parent category page when the tab's own collection is one of the panel links; otherwise the tab's collection.
  // The SHOP overview mega always uses the tab's own collection.
  function shopAllHref(nav, tab, panel) {
    var links = panel.querySelectorAll('a.grandchild-nav__item');
    var top = nav.closest('.main-nav__item--dropdown');
    var parent = top && top.querySelector('.main-nav__row > a');
    if (links.length > 1 && parent && parent.textContent.trim().toUpperCase() !== 'SHOP') {
      var tp = path(tab.href), hit = false;
      links.forEach(function (a) { if (path(a.href) === tp) hit = true; });
      if (hit) return parent.href;
    }
    return tab.href;
  }

  function overrideImage(tab) {
    var src = TAB_IMAGES[path(tab.href)];
    var li = tab.closest('.child-nav__item--toggle');
    var img = li && li.querySelector('.main-nav__collection-image img, img');
    if (!src || !img) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.src = src + '?width=480';
  }

  function enhance(nav) {
    if (nav.getAttribute('data-er-mega')) return;
    nav.setAttribute('data-er-mega', '1');

    nav.querySelectorAll('.grandchild-nav__item').forEach(function (a) {
      var text = (a.textContent || '').trim();
      if (text.indexOf('# ') !== 0) return;
      var li = a.closest('li');
      var span = document.createElement('span');
      span.className = 'er-mega-heading__text';
      span.setAttribute('role', 'heading');
      span.setAttribute('aria-level', '3');
      span.textContent = text.slice(2);
      li.classList.add('er-mega-heading');
      li.replaceChildren(span);
    });

    nav.querySelectorAll('.main-nav__collection-image img').forEach(upsize);

    var Menu = customElements.get('main-menu');
    nav.querySelectorAll('.child-nav__item--toggle').forEach(function (li) {
      var tab = li.querySelector('.main-nav__item-content > a.child-nav__item');
      var panel = li.querySelector(':scope > .child-nav__panel');
      if (!tab || !panel) return;
      overrideImage(tab);

      var head = document.createElement('div');
      head.className = 'er-mega-head';
      var title = document.createElement('span');
      title.className = 'er-mega-head__title';
      title.textContent = tab.textContent.trim();
      var all = document.createElement('a');
      all.className = 'er-mega-head__all';
      all.href = shopAllHref(nav, tab, panel);
      all.textContent = 'Shop All →';
      head.append(title, all);
      panel.insertBefore(head, panel.firstChild);

      // Desktop: clicking a tab selects it (Shop All navigates).
      tab.addEventListener('click', function (e) {
        if (!MQ.matches || !Menu) return;
        e.preventDefault();
        Menu.handleSidenavMenuToggle(null, li);
      });

      var sync = function () { tab.setAttribute('aria-expanded', li.classList.contains('is-visible') ? 'true' : 'false'); };
      sync();
      new MutationObserver(sync).observe(li, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Escape closes any open mega menu (even when only the pointer is over it) and returns focus to its trigger.
  if (!window.__erMegaEsc) {
    window.__erMegaEsc = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !MQ.matches) return;
      var open = document.querySelector('.main-nav__item--dropdown.is-open');
      var menu = document.querySelector('main-menu');
      if (!open || !menu || typeof menu.handleClose !== 'function') return;
      var trigger = open.querySelector('.main-nav__row > a, .main-nav__row > button');
      menu.handleClose();
      if (trigger) trigger.focus({ preventScroll: true });
    });
  }

  function init(root) { (root || document).querySelectorAll('.mega-nav--sidebar').forEach(enhance); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
